<template>
  <div class="container">
    <b-alert class="border border-dark w-100 my-4" show variant="warning">
      <h4 class="alert-heading">
        {{ getContentItem("orderNotFound") }}
      </h4>
      <p
        class="my-4"
      >
        {{ format(getContentItem("orderNotFoundExplanation"), orderNumber, tenantDetails.SupportPhoneNumber) }}
      </p>
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { stringHelper } from "@/components/mixins/stringHelper";

  export default {
    name: "OrderNotFound",
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"])
    },
    mixins: [stringHelper],
    props: {
      orderNumber: String
    }
  };
</script>
